module.exports = "<p>账户权限设定谁可以控制本账户。控制人（账户名或公钥）可修改账户相关的各种设置，包括权限设置。</p>\n<p>参见 <a href=\"accounts/permissions\">权限</a> 了解更多信息。</p>\n";